import { render, staticRenderFns } from "./FormSelectInput.vue?vue&type=template&id=06908c42&"
import script from "./FormSelectInput.vue?vue&type=script&lang=js&"
export * from "./FormSelectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports